import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useT } from "@/i18n";

// Social proof with real, verifiable data only: years, structures, certifications, public works.
const STATS = [["1905", "trust.s1", "Anno di fondazione"], ["944", "trust.s2", "Strutture realizzate"], ["9.000 m³", "trust.s3", "Legno lavorato ogni anno"]];
const CERTS = [["CE", "0407-CPR-1459"], ["ISO 9001", "n. 3919760"], ["PEFC", "CSQA-PEFC-COC-54966"], ["STC", "Attestato 22/22-CL"]];

export const TrustBand = () => {
  const t = useT();
  return (
    <section className="bg-[#EFECE6] px-5 py-20 text-[#121110] sm:px-8 lg:py-24" data-testid="trust-band">
      <div className="mx-auto max-w-[1500px]">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#6E685E]">{t("trust.kicker", "Perché fidarsi")}</p>
        <h2 className="mt-4 max-w-3xl font-display text-3xl font-bold tracking-tight sm:text-4xl">{t("trust.h", "Numeri, certificazioni e opere pubbliche che parlano per noi.")}</h2>
        <div className="mt-12 grid gap-10 lg:grid-cols-12">
          <dl className="grid grid-cols-3 gap-4 lg:col-span-6">
            {STATS.map(([v, k, l]) => (
              <div key={k} className="border-t border-[#121110]/20 pt-4">
                <dt className="font-display text-3xl font-extrabold tracking-tight text-[#C26D38] sm:text-5xl" style={{ fontStretch: "75%" }}>{v}</dt>
                <dd className="mt-2 text-sm text-[#4A453F]">{t(k, l)}</dd>
              </div>
            ))}
          </dl>
          <div className="lg:col-span-6">
            <ul className="grid grid-cols-2 gap-3">
              {CERTS.map(([n, d]) => (
                <li key={n} className="border border-[#121110]/15 bg-[#F7F5F0] px-4 py-3" data-testid={`trust-cert-${n.split(" ")[0].toLowerCase()}`}>
                  <span className="block font-display text-lg font-bold">{n}</span>
                  <span className="block font-mono text-xs text-[#6E685E]">{d}</span>
                </li>
              ))}
            </ul>
            <div className="mt-6 flex flex-wrap gap-x-8 gap-y-3 font-mono text-xs uppercase tracking-[0.18em]">
              <Link to="/#certificazioni" className="tap nav-link inline-flex items-center gap-2" data-testid="trust-link-certs">{t("trust.certs", "Tutte le certificazioni")} <ArrowUpRight className="h-4 w-4" /></Link>
              <Link to="/enti-pubblici" className="tap nav-link inline-flex items-center gap-2" data-testid="trust-link-public">{t("trust.public", "Opere per comuni ed enti pubblici")} <ArrowUpRight className="h-4 w-4" /></Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
